export default __webpack_public_path__ + "static/media/orange-bubble.69107707.svg";